import { useState } from 'react'

import useTranslator from '@/hooks/translation'
import { login } from '@/services/fintalk/services/fintalk-backoffice/auth/login'

import { LoginSchema } from '../components/form/schema'
import { handleAuthError } from '../utils/handle-auth-error'
import { useAuthSession } from './use-auth-session'

type LoginState = { type: 'idle' } | { type: 'loading' } | { type: 'success' }

export const useLogin = () => {
  const { getTranslation } = useTranslator()
  const { enterSession } = useAuthSession()

  const [state, setState] = useState<LoginState>({ type: 'idle' })

  const handleLoginAction = async (data: LoginSchema) => {
    const { email, password } = data

    setState({ type: 'loading' })

    try {
      const tokens = await login({ email, password })

      if (!tokens.access_token || !tokens.refresh_token) {
        throw new Error('Login response is missing tokens')
      }

      await enterSession(tokens)

      setState({ type: 'success' })
    } catch (error) {
      handleAuthError(error, getTranslation)

      setState({ type: 'idle' })
    }
  }

  return {
    state,
    handleLoginAction,
  }
}
